import { render, staticRenderFns } from "./ProfileMeta.vue?vue&type=template&id=76496f72&"
import script from "./ProfileMeta.vue?vue&type=script&lang=js&"
export * from "./ProfileMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports